import { ref, onMounted } from 'vue';
import { useEventListener, useDebounceFn } from '@vueuse/core';
import { getClientWidthFirstChild } from '../utils';
import { Ref } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars

let gridElRef;
const gridItemWidthRef = ref();

function setGridItemWidth() {
  gridItemWidthRef.value = getClientWidthFirstChild(gridElRef.value) || 342;
}

const throttledFnResizeFn = useDebounceFn(() => {
  setGridItemWidth();
}, 1000);

/**
 *
 * @param {Ref<HTMLElement>} gridEl
 * @returns {{gridItemWidth: Ref<number>}}
 */
export default function useGridItemWidth(gridEl) {
  gridElRef = gridEl;

  setGridItemWidth();
  onMounted(() => {
    useEventListener(window, 'resize', throttledFnResizeFn);
  });

  return {
    gridItemWidth: gridItemWidthRef,
  };
}
